import { render, staticRenderFns } from "./view.html?vue&type=template&id=1185aaa8&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=1185aaa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1185aaa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1185aaa8')) {
      api.createRecord('1185aaa8', component.options)
    } else {
      api.reload('1185aaa8', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=1185aaa8&scoped=true&", function () {
      api.rerender('1185aaa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/avatar/index.vue"
export default component.exports